// forked from https://github.com/ngneat/helipopper
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BllHintDirective } from './hint.directive';
import { TIPPY_CONFIG, TippyConfig } from './hint.types';

@NgModule({
  declarations: [BllHintDirective],
  exports: [BllHintDirective],
})
export class BllHintModule {
  static forRoot(config: Partial<TippyConfig> = {}): ModuleWithProviders<BllHintModule> {
    return {
      ngModule: BllHintModule,
      providers: [
        {
          provide: TIPPY_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
